<div class="login-with-mobile-screen form-top-section" *ngIf="!dialogData?.patient">
    <!-- <div class="mb-0 ng-star-inserted"> -->
    <!-- <div class="d-flex justify-content-between"> -->
    <div class="landing-form-back-button-container">
        <a class="" href="javascript:void(0)" (click)="backToLogin()">
            <img src="assets/images/grid-back.png">
        </a>
    </div>
    <div class="landing-form-heading">
        <div class="">
            {{'field.label.sign_in' | translate | async }}
        </div>
        <div class="language-sel" style="font-size: 15px;">
            <dhs-langugage-selection>
            </dhs-langugage-selection>
        </div>
    </div>
    <!-- </div> -->
    <!-- </div> -->
</div>
<ng-container *ngIf="logInWith != 'PIN'">
    <ng-container *ngIf="!verify && !headerInfo.pri_log_otp">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-4" autocomplete="off">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 p-0">
                <div class="floating-input-group c-mb-3" *ngIf="!showFields">
                    <label for="option">{{'field.label.select' | translate | async }}</label>
                    <select formControlName="option" class="form-control" (change)="onChanged()">
                        <option value="">Select</option>
                        <option value="mob">{{'field.label.mobile_number' | translate | async }}</option>
                        <option value="uhid">{{'field.label.UHID' | translate | async }}</option>
                        <option value="email">{{'field.label.email_address' | translate | async }}</option>
                    </select>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="loginForm.value.option == 'mob'">
                    <ng-template #errorTemplate>
                        <div>
                            <div *ngIf="f.mob.errors.required">
                                {{'required.telecom' | translate | async }}
                            </div>
                            <!-- <div *ngIf="f.mob.errors.minlength">
                            {{'field.label.mobile_number_digits' | translate | async }}</div> -->
                            <div *ngIf="f.mob.errors.pattern">
                                {{'field.label.alphabet_cannot_be_accepted' | translate | async }} Or
                                {{'field.label.mobile_number_digits' | translate | async }}
                            </div>
                        </div>
                    </ng-template>
                    <input type="text" formControlName="mob" placeholder=""
                        [ngClass]="{ 'is-invalid': submitted && f.mob.errors }" required
                        class="form-control floating-input"
                        pattern="{{headerInfo.mobile_no_regex?headerInfo.mobile_no_regex:'^[0-9+]{10,12}$'}}" />
                    <label for="mob" class="floating-placeholder">{{'field.label.mobile_number' | translate | async
                        }}</label>
                    <div *ngIf="submitted && f.mob.errors" class="input-detail-error form-v2" [popover]="errorTemplate"
                        triggers="mouseenter:mouseleave">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="loginForm.value.option == 'uhid'">
                    <ng-template #errorTemplate3>
                        <div>
                            <div *ngIf="f.uhid.errors.required">
                                {{'required.UHID' | translate | async }}
                            </div>
                            <div *ngIf="f.uhid.errors.minlength">
                                {{'field.label.UHID_2_digits.' | translate | async }}</div>
                        </div>
                    </ng-template>
                    <input type="text" formControlName="uhid" placeholder=""
                        [ngClass]="{ 'is-invalid': submitted && f.uhid.errors }" required minlength="2" maxlength="18"
                        class="form-control floating-input" />
                    <label for="uhid" class="floating-placeholder">{{'field.label.UHID' | translate | async
                        }}</label>
                    <div *ngIf="submitted && f.uhid.errors" class="input-detail-error form-v2"
                        [popover]="errorTemplate3" triggers="mouseenter:mouseleave">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="loginForm.value.option == 'email'">
                    <ng-template #errorTemplate4>
                        <div>
                            <div *ngIf="f.email.errors.required">
                                {{'required.email_address' | translate | async }}
                            </div>
                        </div>
                    </ng-template>
                    <input type="text" formControlName="email" placeholder=""
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }" required
                        class="form-control floating-input" />
                    <label for="email" class="floating-placeholder">{{'field.label.email_address' | translate | async
                        }}</label>
                    <div *ngIf="submitted && f.email.errors" class="input-detail-error form-v2"
                        [popover]="errorTemplate4" triggers="mouseenter:mouseleave">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                </div>

                <div class="floating-input-group c-mb-3" *ngIf="isKarexpert=='karexpert' && checkSecondaccountUrl">
                    <ng-template #errorTemplate>
                        <div>
                            <div *ngIf="f.account_id.errors.required">
                                {{'required.account_id' | translate | async }}
                            </div>
                            <div *ngIf="f.account_id.errors.minlength">
                                {{'field.label.account_Url_required' | translate | async }}</div>
                            <div *ngIf="f.account_id.errors.pattern">
                                {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}</div>
                        </div>
                    </ng-template>
                    <input type="text" formControlName="account_id" placeholder=""
                        [ngClass]="{ 'is-invalid': submitted && f.account_id.errors }" minlength="2" maxlength="255"
                        pattern="^[a-zA-Z0-9&._@]+" required class="form-control floating-input" />
                    <label for="account_url" class="floating-placeholder">{{'field.label.account_url' | translate |
                        async
                        }}</label>
                    <div *ngIf="submitted && f.account_id.errors" class="input-detail-error form-v2"
                        [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="showFields">
                    <label for="security_question">{{'field.label.select_any' | translate | async }}</label>
                    <select formControlName="security_question" class="form-control" (change)="onChange()"
                        [(ngModel)]="selectedOption">
                        <option value="">{{'field.label.select' | translate | async }}</option>
                        <option value="fname">{{'field.label.firstname' | translate | async }}</option>
                        <option value="uhId">{{'field.label.UHID' | translate | async
                            }}</option>
                    </select>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="showFields">
                    <input type="text" formControlName="security_ans"
                        [placeholder]="loginForm.value.security_question == 'fname'?'First Name':loginForm.value.security_question == 'uhId'?'UHID':''"
                        required class="form-control floating-input" />
                    <label for="security_ans" class="floating-placeholder"
                        *ngIf="loginForm.value.security_question">Enter
                        {{loginForm.value.security_question == 'fname'?'First Name':loginForm.value.security_question ==
                        'uhId'?'UHID':'DOB'}}</label>
                </div>
                <div class="floating-input-group c-mb-3" *ngIf="showGender">
                    <label for="gender">{{'field.label.select_gender' | translate | async }} </label>
                    <select formControlName="gender" class="form-control">
                        <option value="">{{'field.label.select' | translate | async }}</option>
                        <!-- <option *ngFor="let gender of genderData" [value]="gender.code">{{gender.display}}
                    </option> -->
                        <option value="male">{{'field.label.male' | translate | async }}</option>
                        <option value="female">{{'field.label.female' | translate | async }}</option>
                        <option value="transgender-male">{{'field.label.transgender_male' | translate | async }}
                        </option>
                        <option value="transgender-feemale">{{'field.label.transgender_female' | translate | async }}
                        </option>
                        <option value="others">{{'field.label.others' | translate | async }}</option>
                    </select>
                </div>
                 @if (show_captcha && this.headerInfo.additional_authentication_required) {
                <div class="captcha-generate">
                    <div>
                        <dhs-form-question [question]="loginPrimaryForm.controls.captcha.question"
                            [validIn]="submitted && lf.captcha.errors" [form]="loginPrimaryForm">
                        </dhs-form-question>
                    </div>
                </div>
                }
            </div>
            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white">
                    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>
        </form>
    </ng-container>
    <div *ngIf="verify && !headerInfo.pri_log_otp">
        <div class="top-heading mt-2">
            <h5 class="m-0">{{'field.label.Enter_verification_code' | translate | async }}</h5>
        </div>
        <div class="mt-2">
            <!-- <p>We have sent you 6 digit verification code on your mobile to verify contact details.</p> -->
            <p>{{'field.label.Enter_otp' | translate | async }}</p>
        </div>
        <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
        </app-otp-input>

        <div class="col-12 p-0 mt-4">
            <button class="login-button btn-gradient button-hover text-white" (click)="verifyOtp()">
                {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                    aria-hidden="true"></i>
            </button>
        </div>

        <div class="col-12 mt-1 p-0">
            <span *ngIf="!showTimer" class="cLink" (click)="onSubmit()">{{'field.label.resend_OTP' | translate | async
                }}</span>
            <span class="timer" style="cursor: not-allowed; color: gray;" *ngIf="showTimer">
                {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}} {{'field.label.seconds' |
                translate
                | async}}
            </span>
        </div>
    </div>
    <ng-container *ngIf="headerInfo.pri_log_otp">
        <form *ngIf="!verify" [formGroup]="loginPrimaryForm" (ngSubmit)="onPrimaryLogin('SEND_MOB_OTP')" class="mt-4"
            autocomplete="off">
            <div class="floating-input-group c-mb-3">
                <label for="option">{{'field.label.select' | translate | async }}</label>
                <select formControlName="option" class="form-control" (change)="onChanged()">
                    <option value="">Select</option>
                    <option value="mob">{{'field.label.mobile_number' | translate | async }}</option>
                    <option value="uhid">{{'field.label.UHID' | translate | async }}</option>
                    <option value="email">{{'field.label.email_address' | translate | async }}</option>
                </select>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'mob'">
                <ng-template #errorTemplate>
                    <div>
                        <div *ngIf="lf.mob.errors.required">
                            {{'required.telecom' | translate | async }}
                        </div>
                        <div *ngIf="lf.mob.errors.pattern">
                            {{'field.label.alphabet_cannot_be_accepted' | translate | async }} Or
                            {{'field.label.mobile_number_digits' | translate | async }}
                        </div>
                    </div>
                </ng-template>
                <input type="text" formControlName="mob" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.mob.errors }" required
                    class="form-control floating-input"
                    pattern="{{headerInfo.mobile_no_regex?headerInfo.mobile_no_regex:'^[0-9+]{10,12}$'}}" />
                <label for="mob" class="floating-placeholder">{{'field.label.mobile_number' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.mob.errors" class="input-detail-error form-v2" [popover]="errorTemplate"
                    triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'uhid'">
                <ng-template #errorTemplate3>
                    <div>
                        <div *ngIf="lf.uhid.errors.required">
                            {{'required.UHID' | translate | async }}
                        </div>
                        <div *ngIf="lf.uhid.errors.minlength">
                            {{'field.label.UHID_2_digits.' | translate | async }}</div>
                    </div>
                </ng-template>
                <input type="text" formControlName="uhid" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.uhid.errors }" required minlength="2" maxlength="18"
                    class="form-control floating-input" />
                <label for="uhid" class="floating-placeholder">{{'field.label.UHID' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.uhid.errors" class="input-detail-error form-v2" [popover]="errorTemplate3"
                    triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'email'">
                <ng-template #errorTemplate4>
                    <div>
                        <div *ngIf="lf.email.errors.required">
                            {{'required.email_address' | translate | async }}
                        </div>
                    </div>
                </ng-template>
                <input type="text" formControlName="email" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.email.errors }" required
                    class="form-control floating-input" />
                <label for="email" class="floating-placeholder">{{'field.label.email_address' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.email.errors" class="input-detail-error form-v2" [popover]="errorTemplate4"
                    triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="isKarexpert=='karexpert' && checkSecondaccountUrl">
                <ng-template #errorTemplate>
                    <div>
                        <div *ngIf="lf.account_id.errors.required">
                            {{'required.account_id' | translate | async }}
                        </div>
                        <div *ngIf="lf.account_id.errors.minlength">
                            {{'field.label.account_Url_required' | translate | async }}</div>
                        <div *ngIf="lf.account_id.errors.pattern">
                            {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}</div>
                    </div>
                </ng-template>
                <input type="text" formControlName="account_id" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.account_id.errors }" minlength="2" maxlength="255"
                    pattern="^[a-zA-Z0-9&._@]+" required class="form-control floating-input" />
                <label for="account_url" class="floating-placeholder">{{'field.label.account_url' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.account_id.errors" class="input-detail-error form-v2"
                    [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
                <div class="captcha-generate">
                    @if (show_captcha && this.headerInfo.additional_authentication_required) {
                    <div>
                        <dhs-form-question [question]="loginPrimaryForm.controls.captcha.question"
                            [validIn]="submitted && lf.captcha.errors" [form]="loginPrimaryForm">
                        </dhs-form-question>
                    </div>
                    }
                </div>
            </div>
            @if (show_captcha && this.headerInfo?.additional_authentication_required && !isKarexpert) {
            <div class="captcha-generate otpwithlogin">
                <div>
                    <dhs-form-question [question]="loginPrimaryForm.controls.captcha.question"
                        [validIn]="submitted && lf.captcha.errors" [form]="loginPrimaryForm">
                    </dhs-form-question>
                </div>
            </div>
            }
            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white">
                    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>
        </form>
        <div *ngIf="verify && !showFields">
            <div class="top-heading mt-2">
                <h5 class="m-0">{{'field.label.Enter_verification_code' | translate | async }}</h5>
            </div>
            <div class="mt-2">
                <p>{{'field.label.Enter_otp' | translate | async }}</p>
            </div>
            <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
            </app-otp-input>

            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white" (click)="verifyPrimaryOtp()">
                    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>

            <div class="col-12 mt-1 p-0">
                <span *ngIf="!showTimer" class="cLink"
                    (click)="onPrimaryLogin('SEND_MOB_OTP_PIN')">{{'field.label.resend_OTP' | translate
                    |
                    async }}</span>
                <span class="timer" style="cursor: not-allowed; color: gray;" *ngIf="showTimer">
                    {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}} {{'field.label.seconds' |
                    translate | async}}
                </span>
            </div>
        </div>
        <div *ngIf="showFields" class="floating-input-group c-mb-3">
            <label *ngIf="!dialogData?.patient" for="patient_name">{{'slectprimndlog' | translate | async }}</label>
            <label *ngIf="dialogData?.patient" for="patient_name">{{'selectprim' | translate | async }}</label>
            <kx-multiselect-dropdown [placeholder]="Select" tabindex="-1"
                [settings]="patientSearchSelect.defaultsetting" [questions]="patientSearchSelect.question"
                [format]="patientSearchSelect.question.format" name="patient_name"
                [data]="patientSearchSelect.question.datasource" (onSelect)="onItemSelect($event)">
            </kx-multiselect-dropdown>
            <!-- <select class="form-control" [(ngModel)]="patientLoginId" name="patient_name"
                (change)="setPrimary(patientLoginId)" (keydown.enter)="loginPrimary()">
                <option value="">Select</option>
                <option *ngFor="let name of patientList" [value]="name.login_id">{{name.name}} | {{name.login_id}}
                </option>
            </select> -->
            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white" (click)="loginPrimary('priOtpLogin')">
                    {{!dialogData?.patient ? ('button.label.login' | translate | async): 'Set Primary'}} <i
                        class="fa fa-angle-right lg-btn-icon" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-container *ngIf="logInWith == 'PIN'">
    <ng-container>
        <form *ngIf="!verifymPin && !showFieldsMpin && !setmPin" [formGroup]="loginPrimaryForm"
            (ngSubmit)="onPinLogin()" class="mt-4" autocomplete="off">
            <div class="floating-input-group c-mb-3">
                <label for="option">{{'field.label.select' | translate | async }}</label>
                <select formControlName="option" class="form-control" (change)="onChanged()">
                    <option value="">Select</option>
                    <option value="mob">{{'field.label.mobile_number' | translate | async }}</option>
                    <option value="login_id">{{'field.label.login_id' | translate | async }}</option>
                    <option value="email">{{'field.label.email_address' | translate | async }}</option>
                </select>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'mob'">
                <ng-template #errorTemplate>
                    <div>
                        <div *ngIf="lf.mob.errors.required">
                            {{'required.telecom' | translate | async }}
                        </div>
                        <div *ngIf="lf.mob.errors.pattern">
                            {{'field.label.alphabet_cannot_be_accepted' | translate | async }} Or
                            {{'field.label.mobile_number_digits' | translate | async }}
                        </div>
                    </div>
                </ng-template>
                <input type="text" formControlName="mob" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.mob.errors }" required
                    class="form-control floating-input"
                    pattern="{{headerInfo.mobile_no_regex?headerInfo.mobile_no_regex:'^[0-9+]{10,12}$'}}" />
                <label for="mob" class="floating-placeholder">{{'field.label.mobile_number' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.mob.errors" class="input-detail-error form-v2" [popover]="errorTemplate"
                    triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'login_id'">
                <ng-template #errorTemplate>
                    <div>
                        @if (lf.login_id.errors.required) {
                        <div>
                            {{'required.login_id' | translate | async }}</div>
                        }
                        @if (lf.login_id.errors.minlength) {
                        <div>
                            Login Id cannot be less than 2 Character.</div>
                        }
                        @if (lf.login_id.errors.maxlength) {
                        <div>
                            {{'validation.maxlength.login_id' | translate | async }}</div>
                        }
                        @if (lf.login_id.errors.pattern) {
                        <div>
                            {{'validation.pattern' | translate | async }}</div>
                        }
                    </div>
                </ng-template>
                <input type="text" formControlName="login_id" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.login_id.errors }" required minlength="2" maxlength="18"
                    class="form-control floating-input" />
                <label for="login_id" class="floating-placeholder">{{'field.label.login_id' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.login_id.errors" class="input-detail-error form-v2"
                    [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="loginPrimaryForm.value.option == 'email'">
                <ng-template #errorTemplate4>
                    <div>
                        <div *ngIf="lf.email.errors.required">
                            {{'required.email_address' | translate | async }}
                        </div>
                    </div>
                </ng-template>
                <input type="text" formControlName="email" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.email.errors }" required
                    class="form-control floating-input" />
                <label for="email" class="floating-placeholder">{{'field.label.email_address' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.email.errors" class="input-detail-error form-v2" [popover]="errorTemplate4"
                    triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="floating-input-group c-mb-3" *ngIf="isKarexpert=='karexpert' && checkSecondaccountUrl">
                <ng-template #errorTemplate>
                    <div>
                        <div *ngIf="lf.account_id.errors.required">
                            {{'required.account_id' | translate | async }}
                        </div>
                        <div *ngIf="lf.account_id.errors.minlength">
                            {{'field.label.account_Url_required' | translate | async }}</div>
                        <div *ngIf="lf.account_id.errors.pattern">
                            {{'field.label.only_alphabet_hyphen_dot_numbers' | translate | async }}</div>
                    </div>
                </ng-template>
                <input type="text" formControlName="account_id" placeholder=""
                    [ngClass]="{ 'is-invalid': submitted && lf.account_id.errors }" minlength="2" maxlength="255"
                    pattern="^[a-zA-Z0-9&._@]+" required class="form-control floating-input" />
                <label for="account_url" class="floating-placeholder">{{'field.label.account_url' | translate | async
                    }}</label>
                <div *ngIf="submitted && lf.account_id.errors" class="input-detail-error form-v2"
                    [popover]="errorTemplate" triggers="mouseenter:mouseleave">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="top-heading mt-2">
                <h5 class="mb-1 ml-2 ent-mpin">{{'field.label.Enter_mPin' | translate | async }}</h5>
            </div>
            <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
            </app-otp-input>
            <div class="captcha-generate">
                @if (show_captcha && this.headerInfo.additional_authentication_required) {
                <div>
                    <dhs-form-question [question]="loginPrimaryForm.controls.captcha.question"
                        [validIn]="submitted && lf.captcha.errors" [form]="loginPrimaryForm">
                    </dhs-form-question>
                </div>
                }
            </div>
            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white">
                    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>
            <div class="col-12 mt-1 p-0">
                <span class="cLink" (click)="onPrimaryLogin('SEND_MOB_OTP_PIN')">{{'field.label.forgot_reset_mPin' |
                    translate | async
                    }}</span>
            </div>
        </form>
        <div *ngIf="verifymPin">
            <label for="patient_name">{{'slectprimndlog' | translate | async }}</label>
            <kx-multiselect-dropdown [placeholder]="Select" tabindex="-1"
                [settings]="patientSearchSelect.defaultsetting" [questions]="patientSearchSelect.question"
                [format]="patientSearchSelect.question.format" name="patient_name"
                [data]="patientSearchSelect.question.datasource" (onSelect)="onItemSelect($event)">
            </kx-multiselect-dropdown>
            <!-- <select class="form-control" [(ngModel)]="patientLoginId" name="patient_name"
                (change)="setPrimary(patientLoginId)" (keydown.enter)="loginPrimary('pinLogin')">
                <option value="">Select</option>
                <option *ngFor="let name of patientList" [value]="name.login_id">{{name.name}} | {{name.login_id}}
                </option>
            </select> -->
            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white" (click)="loginPrimary('pinLogin')">
                    {{'button.label.login' | translate | async }} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div *ngIf="showFieldsMpin" class="floating-input-group c-mb-3">
            <div class="top-heading mt-2">
                <h5 class="m-0">{{'field.label.Enter_verification_code' | translate | async }}</h5>
            </div>
            <div class="mt-2">
                <p>{{'field.label.Enter_otp' | translate | async }}</p>
            </div>
            <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
            </app-otp-input>

            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white" (click)="setPinOtp()">
                    {{'button.label.next' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>

            <div class="col-12 mt-1 p-0">
                <span *ngIf="!showTimer" class="cLink"
                    (click)="onPrimaryLogin('SEND_MOB_OTP_PIN')">{{'field.label.resend_OTP' |
                    translate
                    |
                    async }}</span>
                <span class="timer" style="cursor: not-allowed; color: gray;" *ngIf="showTimer">
                    {{'field.label.resend_OTP_in_timer_sec' | translate | async }} {{timer}} {{'field.label.seconds' |
                    translate | async}}
                </span>
            </div>
        </div>
        <div *ngIf="setmPin">
            <label for="patient_name">{{'' | translate | async }}</label>
            <kx-multiselect-dropdown [placeholder]="Select" tabindex="-1"
                [settings]="patientSearchSelect.defaultsetting" [questions]="patientSearchSelect.question"
                [format]="patientSearchSelect.question.format" name="patient_name"
                [data]="patientSearchSelect.question.datasource" (onSelect)="onItemSelect($event)">
            </kx-multiselect-dropdown>
            <!-- <select class="form-control" [(ngModel)]="patientLoginId" name="patient_name"
                (change)="setPrimary(patientLoginId)">
                <option value="">Select</option>
                <option *ngFor="let name of patientList" [value]="name.login_id">{{name.name}} | {{name.login_id}}
                </option>
            </select> -->
            <div class="top-heading mt-2">
                <h5 class="m-0">{{'field.label.set_mPin' | translate | async }}</h5>
            </div>
            <div class="mt-2">
                <p>{{'field.label.create_mPin' | translate | async }}</p>
            </div>
            <app-otp-input #ngOtpInput (onInputChange)="pinOtpChange($event)" [config]="config">
            </app-otp-input>

            <div class="mt-2">
                <p>{{'field.label.confirm_mPin' | translate | async }}</p>
            </div>
            <app-otp-input #ngOtpInput (onInputChange)="confirmPinOtpChange($event)" [config]="config">
            </app-otp-input>

            <div class="col-12 p-0 mt-4">
                <button class="login-button btn-gradient button-hover text-white" (click)="saveMpin()">
                    {{'button.label.save_mPin' | translate | async}} <i class="fa fa-angle-right lg-btn-icon"
                        aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>